import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* <p style={{ marginBottom: "unset" }}>&copy; {new Date().getFullYear()} CoreCrate. All rights reserved.</p> */}
        <p style={{ marginBottom: "unset", fontSize:"10px" }}>Copyright &copy; {new Date().getFullYear()} CoreCrate | Powered by Spokesly Inc. All Rights Reserved</p>
      </div>
    </footer>
  );
};

export default Footer;
